// test2667
(2667 && 0);
